const getToken = state => state?.auth?.token
const getStudentId = state => state?.auth?.studentId
const getLastLocation = state => state?.auth?.lastLocation
const getNotificationData = state => state?.auth?.notificationData
const getListOfCountries = state => state?.auth?.listOfCountries
const getUserPermissions = state => state?.auth?.permissions

const selectors = {
  getToken,
  getStudentId,
  getLastLocation,
  getNotificationData,
  getListOfCountries,
  getUserPermissions
}

export default selectors
